import { FormControl, AbstractControl, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';

// Extend the Window interface to include the google namespace
declare global
{
  interface Window { google: any; }
}

// Ensure the google namespace exists
window.google = window.google || {};



export class PAAScoringLogic
{
  controls: { [key: string]: AbstractControl } = {};
  fields: string[] = ['PA1', 'PA2', 'PA3', 'PA4', 'PA5', 'PA6', 'PA7', 'PA8', 'PA9', 'PA10', 'PA11', 'PA12'];
  scoreField: string = 'TOTAL_SCORE';
  async execute(): Promise<void>
  {
    const controlKeys = Object.keys( this.controls );
    let scoreControl: FormControl = new FormControl();
    let total = 0;

    controlKeys.forEach( key =>
    {
      const _key = key.split( '-' )[0];
      if ( _key === this.scoreField )
      {
        scoreControl = this.controls[key] as FormControl;
        scoreControl.disable( { emitEvent: false } );
      }
      if ( this.fields.includes( _key ) )
      {
        const control = this.controls[key];
        total += Number( control.value ) || 0;
      }
      if ( scoreControl )
      {
        scoreControl.setValue( total, { emitEvent: false } );
      }
    } );
  }
}
export class EMpathSelfSufficiencyScoringLogic
{
  controls: { [key: string]: AbstractControl } = {};
  fields: string[] = ['FS_HOUSING', 'FS_FAMILY', 'WB_PHYSICAL', 'WB_NETWORKS', 'FM_DEBTS', 'FM_SAVINGS', 'EDUCATION', 'EARNING_LEVELS'];
  scoreFields: string[] = ['FS_TOTAL', 'WB_TOTAL', 'FM_TOTAL', 'TOTAL_SCORE',];
  async execute(): Promise<void>
  {
    const controlKeys = Object.keys( this.controls );
    let total = 0;
    let other = 0;
    let fsTotal = 0;
    let fmTotal = 0;
    let wbTotal = 0;

    const score = ( field: string, control: string, value: any ) =>
    {
      let scoreControl = this.controls[control];

      switch ( field )
      {
        case 'FS_HOUSING':
          fsTotal += Number( scoreControl.value ) || 0;
          break;
        case 'FS_FAMILY':
          fsTotal += Number( scoreControl.value ) || 0;
          break;
        case 'WB_PHYSICAL':
          wbTotal += Number( scoreControl.value ) || 0;
          break;
        case 'WB_NETWORKS':
          wbTotal += Number( scoreControl.value ) || 0;
          break;
        case 'FM_DEBTS':
          fmTotal += Number( scoreControl.value ) || 0;
          break;
        case 'FM_SAVINGS':
          fmTotal += Number( scoreControl.value ) || 0;
          break;
        default:
          other += Number( scoreControl.value ) || 0;
          break;
      }
      total = fsTotal + wbTotal + fmTotal + other;

    }

    controlKeys.forEach( key =>
    {
      const _key = key.split( '-' )[0];
      if ( this.fields.includes( _key ) )
      {
        score( _key, key, this.controls[key].value );
      }
      else if ( this.scoreFields.includes( _key ) )
      {
        let scoreControl = this.controls[key];
        scoreControl.disable( { emitEvent: false } );
        switch ( _key )
        {
          case 'FS_TOTAL':
            scoreControl.setValue( fsTotal, { emitEvent: false } );
            break;
          case 'WB_TOTAL':
            scoreControl.setValue( wbTotal, { emitEvent: false } );
            break;
          case 'FM_TOTAL':
            scoreControl.setValue( fmTotal, { emitEvent: false } );
            break;
          case 'TOTAL_SCORE':
            scoreControl.setValue( total, { emitEvent: false } );
            break;
        }
      }
    } );
  }
}
export class ControlAddressAutocompleteLogic
{
  constructor()
  {
    // Check if Google Places API is available
    if ( !window.google || !window.google.maps || !window.google.maps.places )
    {
      console.error( 'Google Places API is not available. Please ensure you have included the Google Maps JavaScript API with Places library.' );
    }
  }
  controls: { [key: string]: AbstractControl } = {};
  data: any[] | undefined;
  fields: string[] = ['ADDRESS1', 'CITY', 'COUNTY', 'STATE', 'ZIP_CODE'];
  inputField: string = 'ADDRESS1';
  async execute(): Promise<void>
  {
    // bind autocomplete
    await this.bindAutoComkplete();

    // validate primary
    await this.bindValidatePrimary();
  }

  async bindAutoComkplete(): Promise<void>
  {
    const controlKeys = Object.keys( this.controls );
    let inputControl: HTMLInputElement | undefined;

    controlKeys.forEach( key =>
    {
      const _key = key.split( '-' )[0];
      const _id = key.split( '-' )[1]
      if ( this.inputField === _key )
      {
        inputControl = document.getElementById( _id ) as HTMLInputElement;

        if ( !!inputControl )
        {
          inputControl.toggleAttribute( 'google-places', true );
        }
      }

    } );

    if ( !inputControl ) return;

    // Create a new Autocomplete instance
    const autocomplete = new window.google.maps.places.Autocomplete( inputControl, {
      types: ['address'], // Default to geocode if no types are provided
      fields: ['address_components', 'geometry'], // avoid getting aditional data
      componentRestrictions: { country: ['us', 'ca'] },
    } );

    // Add event listener for place selection
    autocomplete.addListener( 'place_changed', () =>
    {
      const place = autocomplete.getPlace();

      // if no place is selected, return
      if ( !place || !place.geometry )
      {
        console.warn( 'No place selected or place has no geometry.' );
        return;
      }

      // create a varble to hold the place details
      const placeDetails = {
        address1: '',
        city: '',
        county: '',
        state: '',
        country: '',
        zipCode: '',
      };

      // Extract address components from the place
      place.address_components.forEach( ( component: any ) =>
      {
        const { types } = component;
        if ( types.includes( 'street_number' ) )
        {
          placeDetails.address1 = component.long_name;
        } else if ( types.includes( 'route' ) )
        {
          placeDetails.address1 += ` ${component.long_name}`;
        } else if ( types.includes( 'locality' ) )
        {
          placeDetails.city = component.long_name;
        } else if ( types.includes( 'administrative_area_level_2' ) )
        {
          placeDetails.county = component.long_name.replace( 'County', '' ).trim();
        } else if ( types.includes( 'administrative_area_level_1' ) )
        {
          placeDetails.state = component.long_name;
        } else if ( types.includes( 'country' ) )
        {
          placeDetails.country = component.long_name;
        } else if ( types.includes( 'postal_code' ) )
        {
          placeDetails.zipCode = component.long_name;
        }
      } );

      // set binding value to place details
      controlKeys.forEach( key =>
      {
        const _key = key.split( '-' )[0];
        switch ( _key )
        {
          case 'ADDRESS1':
            this.controls[key].setValue( placeDetails.address1, { emitEvent: false } );
            break;
          case 'CITY':
            this.controls[key].setValue( placeDetails.city, { emitEvent: false } );
            break;
          case 'COUNTY':
            this.controls[key].setValue( placeDetails.county, { emitEvent: false } );
            break;
          case 'STATE':
            this.controls[key].setValue( placeDetails.state, { emitEvent: false } );
            break;
          case 'ZIP_CODE':
            this.controls[key].setValue( placeDetails.zipCode, { emitEvent: false } );
            break;
        }
      } );

    } );
  }
  async bindValidatePrimary(): Promise<void>
  {
    const primaryField: string = 'PRIMARY';
    const primarycontrolKey = Object.keys( this.controls ).filter( key => key.startsWith( primaryField ) )[0];
    const primaryControl = this.controls[primarycontrolKey];
    function customValidator( data: any[] ): ValidatorFn 
    {

      return ( control: AbstractControl ): ValidationErrors | null =>
      {
        let primaryCount = 0;
        const primaryFields = data.map( ( entry ) => entry.fields.filter( ( field: any ) => field.name === primaryField ) );
        primaryFields.forEach( ( field: any[] ) =>
        {
          primaryCount = primaryCount + ( field[0].value === 'Y' ? 1 : 0 )
        } );
        return ( control.value === 'Y' && primaryCount >= 1 && primaryFields.length > 1 ) ? { custom: { value: primaryCount } } : null;
      }
    }
    if ( this.data )
    {
      if ( primaryControl.hasValidator( customValidator( this.data ) ) ) return;
      primaryControl.addValidators( customValidator( this.data ) );
      primaryControl.updateValueAndValidity( { emitEvent: false } );
    }
  }
}
export class RelationshipControlLogic
{
  controls: { [key: string]: AbstractControl } = {};
  consentDependentFields: string[] = ['PRIMARY_LANGUAGE'];
  languageDependentFields: string[] = ['LANGUAGE_OTHER', 'INTERPRETER_NEEDED'];
  consentDependentControls: Map<string, AbstractControl> = new Map();
  languageDependentControls: Map<string, AbstractControl> = new Map();
  async execute(): Promise<void>
  {
    const controlKeys = Object.keys( this.controls );

    controlKeys.forEach( key =>
    {
      const _key = key.split( '-' )[0];
      if ( this.consentDependentFields.includes( _key ) ) this.consentDependentControls.set( _key, this.controls[key] );
      if ( this.languageDependentFields.includes( _key ) ) this.languageDependentControls.set( _key, this.controls[key] );
    } );

    controlKeys.forEach( key =>
    {
      const _key = key.split( '-' )[0];


      if ( _key === 'PRIMARY_LANGUAGE' )
      {
        const primaryLanguage = this.controls[key].value || 'English';
        switch ( primaryLanguage.toUpperCase() )
        {
          case 'ENGLISH':
            this.languageDependentControls.forEach( control =>
            {
              control.setValue( null, { emitEvent: false } );
              control.disable( { emitEvent: false } );
            } );
            break;
          case 'OTHER':
            this.languageDependentControls.get( 'LANGUAGE_OTHER' )?.enable( { emitEvent: false } );
            this.languageDependentControls.get( 'INTERPRETER_NEEDED' )?.enable( { emitEvent: false } );
            break;
          default:
            this.languageDependentControls.get( 'LANGUAGE_OTHER' )?.disable( { emitEvent: false } );
            this.languageDependentControls.get( 'INTERPRETER_NEEDED' )?.enable( { emitEvent: false } );
            break;
        }
        return;
      }

      if ( _key === 'CONSENT_TO_SPEAK' )
      {

        if ( this.controls[key].value === 'No' )
        {
          this.consentDependentControls.forEach( control =>
          {
            control.disable( { emitEvent: false } );
            control.setValue( null, { emitEvent: false } );
          } );
          this.languageDependentControls.forEach( control =>
          {
            control.disable( { emitEvent: false } );
            control.setValue( null, { emitEvent: false } );
          } );
        }
        else
        {
          this.consentDependentControls.forEach( control =>
          {
            control.enable( { emitEvent: false } );
          } );
        }
        return;
      }

    } );

  }
}
export class CommunicationsControlLogic
{
  controls: { [key: string]: AbstractControl } = {};
  inputField: string = 'COMM_TYPE';
  dependentFields: string[] = ['COMM_ADDRESS'];
  async execute(): Promise<void>
  {
    const controlKeys = Object.keys( this.controls );
    const inputControl = controlKeys.filter( key => key.startsWith( this.inputField ) ).map( key => this.controls[key] )[0];
    const dependentControls = controlKeys.filter( key => this.dependentFields.includes( key.split( '-' )[0] ) ).map( key => this.controls[key] );

    dependentControls.forEach( control =>
    {
      control.removeValidators( [Validators.email, Validators.pattern( '^[0-9\\-\\+\\(\\) ]*$' )] )
      control.updateValueAndValidity( { emitEvent: false } );
      if ( inputControl.value === 'Email' )
      {
        control.addValidators( [Validators.email] );
      }
      else if ( inputControl.value === 'Phone' )
      {
        control.addValidators( [Validators.pattern( '^[0-9\\-\\+\\(\\) ]*$' )] );
      }
      control.updateValueAndValidity( { emitEvent: false } );
    } );
  }
}

@Injectable( {
  providedIn: 'root'
} )
export class FormSpecialLogic
{
  /// Map of form identifiers to their corresponding special logic classes
  componentMap: Record<string, any[]> = {
    ['T99']: [PAAScoringLogic],
    ['T226']: [EMpathSelfSufficiencyScoringLogic],
    ['S1']: [ControlAddressAutocompleteLogic],
    ['CLIENT_ADDRESS']: [ControlAddressAutocompleteLogic],
    ['S4']: [CommunicationsControlLogic],
    ['COMMUNICATIONS_CONTROL']: [CommunicationsControlLogic],
    ['S5']: [RelationshipControlLogic],
    ['RELATIONSHIP_CONTROL']: [RelationshipControlLogic],
  };

  public async Execute( form: string, controls: { [key: string]: AbstractControl<any, any> } ): Promise<void>
  public async Execute( form: string, controls: { [key: string]: AbstractControl<any, any> }, data: any[] ): Promise<void>
  /** Executes the special logic for the given form and controls.
    * @param form The form identifier.
    * @param controls The form controls.
    */
  public async Execute( form: string, controls: { [key: string]: AbstractControl<any, any> }, data?: any[] ): Promise<void>
  {
    var logicInstances = this.GetLogicInstance( form );
    if ( logicInstances )
    {
      logicInstances.forEach( async logicInstance =>
      {
        const instance = new logicInstance();
        instance.controls = controls;
        if ( data )
        {
          instance.data = data;
        }
        await instance.execute();
      } );
    }
  }
  public async HasSpecialLogic( form: string ): Promise<boolean>
  {
    var logicInstances = this.GetLogicInstance( form );
    return logicInstances ? true : false;
  }
  private GetLogicInstance( form: string ): any[] | undefined
  {
    return this.componentMap[form] || undefined;
  }

}


